"use client";

import { cn } from "../../lib";

export interface FieldCharCountBadgeProps {
	current: number;
	max: number;
	id?: string;
	className?: string;
	/** When true, emphasize near/at limit (mention composers). */
	emphasizeNearLimit?: boolean;
}

/**
 * Shared inset-end character count for FieldTypes text controls.
 * Presentation: `text-xs text-muted-foreground tabular-nums`.
 */
export function FieldCharCountBadge({
	current,
	max,
	id,
	className,
	emphasizeNearLimit = false,
}: FieldCharCountBadgeProps) {
	const nearLimit = emphasizeNearLimit && current >= max;
	return (
		<span
			id={id}
			data-testid={id}
			className={cn(
				"pointer-events-none text-xs tabular-nums text-muted-foreground",
				nearLimit && "text-foreground/80",
				className,
			)}
			aria-live="polite"
		>
			{current}/{max}
		</span>
	);
}
